import { useState } from "react";

import { FaChevronRight } from "react-icons/fa";
const SidebarButtonGroup = ({
  sideToggle,
  headerToggle,
  children,
  title,
  icon,
}) => {
  const [toggle, setToggle] = useState(false);
  const handleToggle = () => {
    setToggle(!toggle);
  };

  return (
    <div
      className={`w-full   transition-all max-h-12  duration-300 ease-out ${
        toggle && "bg-slate-600/30"
      } `}
      style={{
        maxHeight: toggle && (children.length + 2) * 3 + "rem",
        overflow: "clip",
      }}
    >
      <button
        onClick={handleToggle}
        className={`group hover:bg-primary/20 flex items-center h-12 w-full transition-all duration-300 ease-out ${
          !sideToggle ? " px-6 space-x-5 justify-between " : " justify-center "
        }`}
      >
        <div className="flex items-center space-x-5">
          {icon}
          <span
            className={`${
              (sideToggle || headerToggle) &&
              " absolute opacity-0 invisible transition-none"
            }  transition-all duration-500 ease-out whitespace-nowrap`}
          >
            {title}
          </span>
        </div>

        {!sideToggle && (
          <FaChevronRight
            className={`${toggle && "rotate-90"} transition-all`}
          />
        )}
      </button>
      {children}
    </div>
  );
};

export default SidebarButtonGroup;
